import { ExprNode } from '@mode-switch/express';
import { RelationCore } from './Relation/RelationCore';
import { RelationNode } from './Relation/RelationNode';
export var Relation;
(function (Relation) {
    function make(core) {
        return RelationNode.select(core);
    }
    Relation.make = make;
    function project(relation, projectionNode) {
        const { cores } = relation;
        return {
            ...relation,
            cores: [
                ...cores.slice(0, cores.length - 1),
                RelationCore.project(cores[cores.length - 1], projectionNode),
            ],
        };
    }
    Relation.project = project;
    function from(relation, fromNode) {
        const { cores } = relation;
        return {
            ...relation,
            cores: [
                ...cores.slice(0, cores.length - 1),
                RelationCore.from(cores[cores.length - 1], fromNode),
            ],
        };
    }
    Relation.from = from;
    function join(relation, joinNodes) {
        const { cores } = relation;
        return {
            ...relation,
            cores: [
                ...cores.slice(0, cores.length - 1),
                RelationCore.join(cores[cores.length - 1], joinNodes),
            ],
        };
    }
    Relation.join = join;
    function where(relation, exprs) {
        const { cores } = relation;
        return {
            ...relation,
            cores: [
                ...cores.slice(0, cores.length - 1),
                RelationCore.where(cores[cores.length - 1], exprs),
            ],
        };
    }
    Relation.where = where;
    function group(relation, exprs) {
        const { cores } = relation;
        return {
            ...relation,
            cores: [
                ...cores.slice(0, cores.length - 1),
                RelationCore.group(cores[cores.length - 1], exprs),
            ],
        };
    }
    Relation.group = group;
    function having(relation, exprs) {
        const { cores } = relation;
        return {
            ...relation,
            cores: [
                ...cores.slice(0, cores.length - 1),
                RelationCore.having(cores[cores.length - 1], exprs),
            ],
        };
    }
    Relation.having = having;
    function order(relation, terms) {
        const currOder = relation.order || RelationNode.order();
        return {
            ...relation,
            order: { ...currOder, terms: [...currOder.terms, ...terms] },
        };
    }
    Relation.order = order;
    function limit(relation, expr) {
        return { ...relation, limit: RelationNode.limit(expr) };
    }
    Relation.limit = limit;
    function offset(relation, expr) {
        return { ...relation, offset: RelationNode.offset(expr) };
    }
    Relation.offset = offset;
    function reduce(initial, node, reducer, parent) {
        if (node == null) {
            return initial;
        }
        switch (node.type) {
            case "PROJ":
                initial = reduce(initial, node.expr, reducer, node);
                initial = reduce(initial, node.alias, reducer, node);
                break;
            case "TABLE":
                initial = reduce(initial, node.name, reducer, node);
                break;
            case "FROM":
                initial = reduce(initial, node.source, reducer, node);
                initial = reduce(initial, node.alias, reducer, node);
                break;
            case "JOIN":
                initial = reduce(initial, node.source, reducer, node);
                initial = reduce(initial, node.predicate, reducer, node);
                initial = reduce(initial, node.alias, reducer, node);
                break;
            case "ORDER":
                for (const term of node.terms) {
                    initial = reduce(initial, term, reducer, node);
                }
                break;
            case "ORDER_TERM":
                initial = reduce(initial, node.expr, reducer, node);
                break;
            case "WHERE":
            case "GROUP":
            case "HAVING":
            case "WINDOW":
                for (const expr of node.exprs) {
                    initial = reduce(initial, expr, reducer, node);
                }
                break;
            case "LIMIT":
            case "OFFSET":
                initial = reduce(initial, node.expr, reducer, node);
                break;
            case "CORE":
                if (node.projections != null) {
                    for (const projection of node.projections) {
                        initial = reduce(initial, projection, reducer, node);
                    }
                }
                if (node.from != null) {
                    initial = reduce(initial, node.from, reducer, node);
                }
                if (node.joins != null) {
                    for (const joinNode of node.joins) {
                        initial = reduce(initial, joinNode, reducer, node);
                    }
                }
                if (node.where != null) {
                    initial = reduce(initial, node.where, reducer, node);
                }
                if (node.group != null) {
                    initial = reduce(initial, node.group, reducer, node);
                }
                if (node.having != null) {
                    initial = reduce(initial, node.having, reducer, node);
                }
                if (node.window != null) {
                    initial = reduce(initial, node.window, reducer, node);
                }
                break;
            case "SELECT": {
                for (const nodeCore of node.cores) {
                    initial = reduce(initial, nodeCore, reducer, node);
                }
                if (node.order != null) {
                    initial = reduce(initial, node.order, reducer, node);
                }
                if (node.limit != null) {
                    initial = reduce(initial, node.limit, reducer, node);
                }
                if (node.offset != null) {
                    initial = reduce(initial, node.offset, reducer, node);
                }
                break;
            }
            default: {
                if (parent == null) {
                    return ExprNode.reduce(initial, node, reducer);
                }
                switch (parent.type) {
                    case "PROJ":
                    case "TABLE":
                    case "FROM":
                    case "JOIN":
                    case "ORDER":
                    case "ORDER_TERM":
                    case "WHERE":
                    case "GROUP":
                    case "HAVING":
                    case "WINDOW":
                    case "LIMIT":
                    case "OFFSET":
                    case "CORE":
                    case "SELECT":
                        return ExprNode.reduce(initial, node, reducer);
                    default:
                        return ExprNode.reduce(initial, node, reducer, parent);
                }
            }
        }
        return reducer(initial, node, parent);
    }
    Relation.reduce = reduce;
})(Relation || (Relation = {}));
